import { DefaultError, useMutation } from "@tanstack/react-query";
import { useQueryToast } from "hooks";
import i18next from "i18next";
import { apiClient } from "utils";
import { useResponseHandler } from "utils/service/responseHandler";

export const useAddMerchImage = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useAddMerchImage");
  return useMutation<
    {},
    DefaultError,
    { file: File; id: string; isMain: boolean }
  >({
    mutationFn: async (body) => {
      loading(
        i18next.t("service-message.create.loading", {
          what: i18next.t("merch.image-what"),
        })
      );

      const formData = new FormData();

      formData.append("file", body.file);
      formData.append("id", body.id);
      formData.append("isMain", `${body.isMain}`);

      const response = await apiClient<FormData>({
        method: "POST",
        url: `Merch/ImageForm`,
        body: formData,
        withContentType: false,
      });

      return responseHandler(response, {
        groupName: "useAddMerchImage",
      });
    },
    onSuccess: (data) => {
      success(
        i18next.t("service-message.create.success", {
          what: i18next.t("merch.image-what"),
        })
      );
    },
    onError: dismiss,
  });
};

export const useDeleteMerchImage = (merchId: string) => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useDeleteMerchImage");

  return useMutation<{}, DefaultError, { imageId: string }>({
    mutationFn: async ({ imageId }) => {
      loading(
        i18next.t("service-message.delete.loading", {
          what: i18next.t("merch.image-what"),
        })
      );

      const response = await apiClient({
        method: "DELETE",
        url: `Merch/${merchId}/Image/${imageId}`,
      });

      return responseHandler(response, {
        groupName: "useDeleteMerchImage",
      });
    },
    onSuccess: () => {
      success(
        i18next.t("service-message.delete.success", {
          what: i18next.t("merch.image-what"),
        })
      );
    },
    onError: dismiss,
  });
};
